import React from 'react';
import { Grid } from '@mui/material';
import SectionHeader from '../../ui/SectionHeader';
import ArticlePreviewList from '../../ui/ArticlePreviewList';
import { useParams } from 'react-router-dom';
import { useActivityLogger } from '../../hooks/use-activity-logger';
import moment from 'moment';

const ArchivesPage: React.FC = () => {
    const { dateId } = useParams<{ dateId?: string }>();
    const date = moment(dateId);
    const dateDisplay = date.format('MMMM YYYY');

    useActivityLogger('Archives', dateDisplay, dateId);

    return (
        <Grid size={12}>
            <SectionHeader
                id="archives-header-section"
                title={`All articles published in ${dateDisplay}`}
                subtitle="A list of all articles published in this period of time"
            />
            <ArticlePreviewList
                dateFrom={date.toDate()}
                dateTo={date.endOf('month').toDate()}
                source="Archives Page"
            />
        </Grid>
    );
};

export default ArchivesPage;
